import ArrowBackwardSquare from './ArrowBackwardSquare';

export default ArrowBackwardSquare;
